import { render, staticRenderFns } from "./puInstock.vue?vue&type=template&id=716c73af"
import script from "./puInstock.vue?vue&type=script&lang=js"
export * from "./puInstock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports